import { BlogSection } from '@/types/blog';

export const finanztagebuchSection: BlogSection = {
  id: 'finanztagebuch',
  title: 'Bewusstes Finanz-Tagebuch führen',
  content: `
    <h3>1. Bewusstes Finanz-Tagebuch führen</h3>
    
    <p>
      Schreibe eine Woche lang auf, wann und warum du Geld ausgibst. Notiere nicht nur den Betrag, sondern auch 
      deine Emotionen dabei. Kaufst du aus Freude, Frust oder Langeweile? Studien zeigen, dass allein das 
      Bewusstmachen von Mustern hilft, impulsives Verhalten zu reduzieren (Prelec & Loewenstein, 1998).
    </p>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">Praktische Übung: Finanz-Tagebuch</h4>
      <p class="mb-2">Erstelle eine einfache Tabelle mit folgenden Spalten:</p>
      <ul class="list-disc pl-5 mb-3">
        <li>Datum und Uhrzeit</li>
        <li>Ausgabe/Einnahme</li>
        <li>Betrag</li>
        <li>Gefühl vor dem Kauf (1-10)</li>
        <li>Gefühl nach dem Kauf (1-10)</li>
        <li>Notizen (Warum habe ich das gekauft?)</li>
      </ul>
      <p>Führe dieses Tagebuch für mindestens 7 Tage und reflektiere anschließend deine Muster.</p>
    </div>
  `
};